(() => {
  const root = document.getElementById('gw-anniversary');
  if (!root) return;
  const code = root.dataset.code;
  const endsAt = root.dataset.endsAt ? Date.parse(root.dataset.endsAt) : null;
  const dialog = root.querySelector('dialog');
  const launcher = root.querySelector('[data-gw-offer-open]');
  const claimButton = root.querySelector('[data-gw-offer-claim]');
  const error = root.querySelector('[data-gw-offer-error]');
  const storageKey = `gw-anniversary:${code}`;
  const seenKey = `${storageKey}:seen`;
  const routesRoot = `${root.dataset.root.replace(/\/$/, '')}/`;
  let claimed = false;
  let claiming = false;
  let needsReload = false;
  let expiryTimer;
  let autoTimer;
  let unsubscribe;
  let previousFocus;
  let previousOverflow = '';

  const active = () => endsAt === null || (Number.isFinite(endsAt) && Date.now() < endsAt);
  const storage = (type, action, key, value) => {
    try { return window[type][action](key, value); } catch { return null; }
  };
  const showClaimed = (value) => {
    claimed = value;
    document.documentElement.classList.toggle('gw-anniversary-ready', value && active());
    root.querySelectorAll('[data-gw-unclaimed]').forEach((node) => { node.hidden = value; });
    root.querySelectorAll('[data-gw-claimed]').forEach((node) => { node.hidden = !value; });
  };
  const forget = () => {
    showClaimed(false);
    storage('localStorage', 'removeItem', storageKey);
  };
  const accepted = (cart) => (cart.discount_codes || []).some((discount) =>
    discount.code.toUpperCase() === code.toUpperCase() && (cart.item_count === 0 || discount.applicable)
  );
  const cartRequest = async (apply = false) => {
    const response = await fetch(`${routesRoot}cart${apply ? '/update' : ''}.js`, {
      method: apply ? 'POST' : 'GET',
      credentials: 'same-origin',
      signal: AbortSignal.timeout(12000),
      headers: { Accept: 'application/json', ...(apply ? { 'Content-Type': 'application/json' } : {}) },
      ...(apply ? { body: JSON.stringify({ discount: code }) } : {})
    });
    if (!response.ok) throw new Error('Coupon request failed');
    return response.json();
  };
  const open = () => {
    if (!active() || dialog.open) return;
    clearTimeout(autoTimer);
    previousFocus = document.activeElement;
    previousOverflow = document.body.style.overflow;
    dialog.showModal();
    document.body.style.overflow = 'hidden';
    storage('sessionStorage', 'setItem', seenKey, '1');
    if (!claimed) claimButton.focus({ preventScroll: true });
    else dialog.querySelector('[data-gw-claimed] button').focus({ preventScroll: true });
  };
  const expire = () => {
    clearTimeout(autoTimer);
    forget();
    launcher.hidden = true;
    if (dialog.open) dialog.close();
    unsubscribe?.();
  };
  const scheduleExpiry = () => {
    if (endsAt === null) return;
    clearTimeout(expiryTimer);
    const remaining = endsAt - Date.now();
    if (remaining <= 0) expire();
    else expiryTimer = setTimeout(scheduleExpiry, Math.min(remaining, 2147483647));
  };
  const verify = async () => {
    if (!claimed || !active() || claiming) return;
    try {
      const cart = await cartRequest();
      if (!accepted(cart)) forget();
    } catch {
      showClaimed(false);
    }
  };

  if (!active() || typeof dialog.showModal !== 'function') return;
  const endLabel = root.querySelector('[data-gw-offer-end]');
  if (endLabel && Number.isFinite(endsAt)) {
    endLabel.textContent = new Intl.DateTimeFormat(document.documentElement.lang || 'en-US', {
      year: 'numeric', month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit',
      timeZone: 'America/Los_Angeles', timeZoneName: 'short'
    }).format(new Date(endsAt));
  }
  launcher.addEventListener('click', open);
  root.querySelectorAll('[data-gw-offer-close]').forEach((button) => button.addEventListener('click', () => { if (!claiming) dialog.close(); }));
  dialog.addEventListener('cancel', (event) => { if (claiming) event.preventDefault(); });
  dialog.addEventListener('close', () => {
    document.body.style.overflow = previousOverflow;
    if (needsReload) { window.location.reload(); return; }
    if (previousFocus?.isConnected) previousFocus.focus({ preventScroll: true });
  });
  claimButton.addEventListener('click', async () => {
    if (claiming || !active()) return;
    claiming = true;
    claimButton.disabled = true;
    claimButton.textContent = root.dataset.applying;
    error.textContent = '';
    try {
      const cart = await cartRequest(true);
      if (!active() || !accepted(cart)) throw new Error('Coupon unavailable');
      storage('localStorage', 'setItem', storageKey, 'claimed');
      showClaimed(true);
      needsReload = cart.item_count > 0;
      dialog.querySelector('[data-gw-claimed] button').focus({ preventScroll: true });
    } catch {
      forget();
      error.textContent = root.dataset.error;
    } finally {
      claiming = false;
      claimButton.disabled = false;
      claimButton.textContent = root.dataset.claimLabel;
    }
  });

  scheduleExpiry();
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    unsubscribe = subscribe(PUB_SUB_EVENTS.cartUpdate, verify);
  }
  window.addEventListener('pageshow', (event) => { if (event.persisted) verify(); });
  document.addEventListener('visibilitychange', () => { if (!document.hidden && !active()) expire(); });

  const start = async () => {
    const startedAt = Date.now();
    if (storage('localStorage', 'getItem', storageKey) === 'claimed') {
      try {
        const cart = await cartRequest();
        if (accepted(cart)) showClaimed(true);
        else forget();
      } catch { showClaimed(false); }
    }
    if (!active()) return;
    launcher.hidden = false;
    if (claimed || storage('sessionStorage', 'getItem', seenKey) || window.Shopify?.designMode) return;
    const delay = Math.max(2000, Number(root.dataset.delay) || 3000);
    const tryOpen = () => {
      if (!active() || claimed) return;
      if (document.hidden || document.querySelector('dialog[open], .shopify-pc__banner__dialog, cart-drawer.active, details-modal details[open]')) {
        autoTimer = setTimeout(tryOpen, 1000);
        return;
      }
      open();
    };
    autoTimer = setTimeout(tryOpen, Math.max(0, delay - (Date.now() - startedAt)));
  };
  start();
})();
